/* eslint-disable import/prefer-default-export */
import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";

export const useAttackTactics = (projectId, config = {}) => {
  return ReactQuery.useQuery({
    ...config,
    queryKey: ["attackTactics", projectId],
    queryFn: () => Brm.attackTacticApi.findAttackTactic(projectId),
  });
};
